import { render } from "./PerfGraph.vue?vue&type=template&id=40c5a8f4"
import script from "./PerfGraph.vue?vue&type=script&lang=js"
export * from "./PerfGraph.vue?vue&type=script&lang=js"

import exportComponent from "/home/welchome/public_html/www/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__